<template>
    <div
        :class="{'uk-open': selecting }"
        class="uk-button-dropdown"
    >
        <base-button
            class="uk-button uk-width-1-1 uk-text-left"
            @click.prevent="clicked"
        >
            <open-icon :glyph="glyph" />
            <slot name="label">{{ value }}</slot>
            <open-icon
                v-if="selectable"
                glyph="caret-down"
            />
        </base-button>
        <div
            v-if="selectable&&selecting"
            class="uk-dropdown"
        >
            <ul class="uk-nav uk-nav-dropdown">
                <li
                    v-for="option in options"
                    :key="option[idField]"
                >
                    <a
                        href
                        @click.prevent="pick(option)"
                    >
                        {{ option[labelField] }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import is_nibnut_component from "../mixins/IsNibnutComponent"

import BaseButton from "./BaseButton"
import OpenIcon from "./OpenIcon"

export default {
    name: "FormSegmentedControl",
    mixins: [is_nibnut_component],
    components: {
        BaseButton,
        OpenIcon
    },
    methods: {
        clicked () {
            if(this.selectable) this.selecting = !this.selecting
        },
        pick (option) {
            if(this.editable) this.$emit("input", option[this.idField], this.name, option)
            this.selecting = false
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: null
        },
        idField: {
            type: String,
            default: "id"
        },
        labelField: {
            type: String,
            default: "title"
        },
        options: {
            type: Array,
            default () {
                return []
            }
        },
        glyph: {
            type: String,
            default: "link"
        },
        width: {
            type: String,
            default: "1-1"
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal|large)$/i),
            default: "normal"
        },
        editable: {
            type: Boolean,
            default: true
        },
        selectable: {
            type: Boolean,
            default: true
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            selecting: false
        }
    }
}
</script>
